import { render, staticRenderFns } from "./scholarHotWord.vue?vue&type=template&id=305d1ba3&scoped=true"
import script from "./scholarHotWord.vue?vue&type=script&lang=js"
export * from "./scholarHotWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305d1ba3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305d1ba3')) {
      api.createRecord('305d1ba3', component.options)
    } else {
      api.reload('305d1ba3', component.options)
    }
    module.hot.accept("./scholarHotWord.vue?vue&type=template&id=305d1ba3&scoped=true", function () {
      api.rerender('305d1ba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/scholarHotWord.vue"
export default component.exports